import { Box, Typography } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";
import React from "react";

const TableCustomNoData = () => {
  return (
    <GridOverlay>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center",
          p: 2,
        }}
      >
        {/* <img src={NoDataSVG} alt="No Data" width="120px" /> */}
        <Typography variant="body1" sx={{ mt: 1, fontWeight: 500 }}>
          No data available
        </Typography>
      </Box>
    </GridOverlay>
  );
};

export default TableCustomNoData;
